module.exports = __webpack_public_path__ + "img/15.0d4bbe58.svg";